export class DeviceParamGatewayV3Server {
    public use_ssl: boolean = true;
    public gw_firmware: {url: string, version: string} = {url: 'https://storeserver.osmos-group.com/LV3/update/gateway', version: ''}
    public liris_firmware:  {url: string, version: string} = {url: 'https://storeserver.osmos-group.com/LV3/update/gateway', version: ''}
    public config: string = 'https://storeserver.osmos-group.com/server/application.php';
    public data: string = 'https://storeserver.osmos-group.com/server/application.php';
}
